"use client";

import { createAuthClient } from "better-auth/client";
import { useState } from "react";

export function useGoogleSignIn() {
    const authClient = createAuthClient();
    const [loading, setLoading] = useState(false);

    const signIn = async () => {
        setLoading(true);
        const res = await authClient.signIn.social({
            provider: "google",
            callbackURL: "/dashboard",
        });
        setLoading(false);
    };

    return { signIn, loading };
}
